export enum TipoExpendedora {
    ABASTECEDORA_CAMION,
    SURTIDOR,
    DISPENSER
}